import { z } from 'zod';
export const ActionItemSchema = z.object({
    description: z.string().min(1),
    assigneeName: z.string().optional(),
    dueDate: z.string().optional(), // ISO date string "YYYY-MM-DD"
    status: z.enum(['open', 'done', 'cancelled']).default('open'),
});
//# sourceMappingURL=actionItem.js.map